module.exports = __webpack_public_path__ + "static/example_6_month-875661b6b75dd65e849a0df04393e12d.png";